<template>
  <div class="panel-body">
    <v-dialog persistent v-model="cardIncentiveDialog" max-width="1000px">
        <cardIncentive
          :card="this.card"
          :incentiveKey="this.incentiveKey"
          :actionIncentive="this.selectedIncentive"
          @close-card-incentive="cardIncentiveClose"
          @save-card-incentive="cardIncentiveSave"
        ></cardIncentive>
    </v-dialog>
    <v-card>
      <v-card-title>Incentives for Card - {{this.card.title}}</v-card-title>
      <template>
       <v-container>
          <v-layout>
            <v-flex xs12 sm6 md4>
              <!-- <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn> -->
              <v-btn @click="newIncentive" color="primary" dark class="mb-2">New Incentive</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card>
            <v-data-table
                :v-model="incentiveSelected"
                :headers="headers"
                :items="cardActionIncentives"
                :loading="loadingData"
                item-key="id"
                class="elevation-1"
                :rows-per-page="incRowsPerPage"
                :items-per-page-options="incRppItems"
            >
                <template v-slot:top>
                <v-card-title>Card Incentives</v-card-title>
                </template>
                <template slot="item" slot-scope="props">
                    <tr>
                    <td class="text-xs-left" @click="editIncentive(props.item)">{{ props.item.id }}</td>
                    <td class="text-xs-left" @click="editIncentive(props.item)">{{ props.item.action }}</td>
                    <td class="text-xs-left" @click="editIncentive(props.item)">{{ formatContestNames(props.item.incentiveTemplate.contests) }}</td>
                    <td class="text-xs-left" @click="editIncentive(props.item)">{{ props.item.incentiveTemplate.amount }}</td>
                    <td class="text-xs-left" @click="editIncentive(props.item)">{{ props.item.incentiveTemplate.amountAvailable }}</td>
                    <td class="text-xs-left" @click="editIncentive(props.item)">{{ props.item.startDate }}</td>
                    <td class="text-xs-left" @click="editIncentive(props.item)">{{ props.item.endDate }}</td>
                    <td class="justify-center layout px-4">
                        <v-icon small @click="deleteIncentive(props.item)">visibility</v-icon>
                    </td>
                    </tr>
                </template>
                <template slot="no-data"></template>
            </v-data-table>
            <v-layout wrap>
                <v-spacer/>
                <v-btn color="blue darken-1" text @click="close">Close</v-btn>
            </v-layout>
        </v-card>
      </template>
    </v-card>

  </div>
</template>

<script>
import moment from 'moment'
import cardIncentive from '@/components/CardIncentive.vue'
let rh = require('@/components/APIs/RequestHandler')
let mh = require('@/components/APIs/MessageHandler')

export default {
  props: {
    card: {
      required: true
    },
    incentivesKey: {
      requred: true
    }
  },
  data: () => ({
    incentiveKey: 0,
    incRppItems: [
      5,
      10,
      15,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    incRowsPerPage: 10,
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Action', value: 'action' },
      { text: 'Contests', value: 'incentiveTemplate.contests' },
      { text: 'Ballot/Action', value: 'incentiveTemplate.amount' },
      { text: 'Max Ballots', value: 'incentiveTemplate.amountAvailable' },
      {
        text: 'Start',
        value: 'startDate',
        filter: value => {
          return true
        }
      },
      {
        text: 'End',
        value: 'endDate',
        filter: value => {
          return true
        }
      }
    ],
    cardActionIncentives: [],
    initialCardActionIncentives: [],
    cardIncentiveDialog: false,
    dialog: false,
    incentiveSelected: null,
    loadingData: false,
    selectedIncentive: null
  }),

  created () {
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    card: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadActionIncentivesForCard()
      }
    }
  },
  components: {
    cardIncentive
  },
  computed: {},
  methods: {
    formatContestNames (contests) {
      if (contests !== null) {
        var allContests = ''
        for (var i = 0; i < contests.length; i++) {
          if (i === 0) {
            allContests = contests[0]
          } else {
            allContests = allContests + ', ' + contests[0]
          }
        }
        return allContests
      }
      return ''
    },
    cardIncentiveClose () {
      this.cardIncentiveDialog = false
    },
    cardIncentiveSave () {
      this.cardIncentiveDialog = false
      this.loadActionIncentivesForCard()
    },
    async loadActionIncentivesForCard () {
      this.loadingData = true
      var cardId = this.card.id
      const actionIncentivesEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_INCENTIVE}/actionIncentiveTemplates?sourceType=CARD&sourceId=${cardId}`
      var actionIncResponse = await rh.default.get(actionIncentivesEndpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (actionIncResponse === undefined || actionIncResponse.data === '') {
        this.initialCardActionIncentives = []
      } else {
        this.initialCardActionIncentives = actionIncResponse.data
      }
      this.cardActionIncentives = [...this.initialCardActionIncentives]
      this.loadingData = false
    },
    close () {
      this.dialog = false
      this.$emit('close-card-incentives')
    },
    async save () {
      this.dialog = false
      this.$emit('save-card-incentives')
    },
    revert () {
      this.editMessages = JSON.parse(JSON.stringify(this.messages))
      this.setupEdit()
    },
    open () {

    },
    async setupEdit () {

    },
    newIncentive () {
      this.incentiveKey++
      this.selectedIncentive = null
      this.cardIncentiveDialog = true
    },
    editIncentive (incentive) {
      this.selectedIncentive = incentive
      this.cardIncentiveDialog = true
    },
    async deleteIncentive (incentive) {
      var id = incentive.id
      var index = this.cardActionIncentives.indexOf(incentive)
      if (incentive !== null) {
        const actionIncentiveDeleteEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_INCENTIVE}/actionIncentiveTemplates/${id}`
        if (confirm(`Are you sure you want to delete this incenvtive (id ${id})?`)) {
          var delResponse = await rh.default.delete(actionIncentiveDeleteEndpoint, true).catch(e => {
            this.errors.push(e)
          })
          this.loadActionIncentivesForCard()
        }
      }
    }
  }
}
</script>
